// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"576bde2c","667":"9f88c49e"}[chunkId] + ".chunk.js";
};